var available;

// modernizr's approach: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
export function isLocalStorageAvailable() {
  if (available) {
    return true;
  }
  var testValue = "feedback_form_".concat(Number(Date.now()));
  try {
    localStorage.setItem(testValue, testValue);
    localStorage.removeItem(testValue);
    available = true;
    return true;
  } catch (e) {
    return false;
  }
}